export class DashOtif {
  descricaoFornecedorSap: string;
  codigoFornecedorSap: number;
  numeroContrato: number;
  dia: Date;
  sku: number;
  descricao: string;
  quantidadePlanejada: number;
  quantidadeProduzida: number;
  quantidadeFaturada: number;
  dataCarregamento: Date;
  dataEntregaPrevista: Date;
  dataEntrega: Date;
  codigoCentroDestino: number;
  descricaoCentroDestino: string;
  statusEntrega: string;
  otif: number;
  lostShelfLife: number;
  justificativa: string;
  quantidadeCompensacao: number;
  recupera: number;
  semana: number;
  compensa: boolean;
  sobra: number;
  falta: number;
  dataCompensacao?: Date;
  desvio: number;
  semanaCompensacao: number;

  constructor(
    descricaoFornecedorSap: string,
    codigoFornecedorSap: number,
    numeroContrato: number,
    dia: Date,
    sku: number,
    descricao: string,
    quantidadePlanejada: number,
    quantidadeProduzida: number,
    quantidadeFaturada: number,
    dataCarregamento: Date,
    dataEntregaPrevista: Date,
    dataEntrega: Date,
    codigoCentroDestino: number,
    descricaoCentroDestino: string,
    statusEntrega: string,
    otif: number,
    lostShelfLife: number,
    justificativa: string,
    quantidadeCompensacao: number,
    recupera: number,
    semana: number,
    compensa: boolean,
    sobra: number,
    falta: number,
    desvio: number,
    semanaCompensacao: number,
    dataCompensacao?: Date
  ) {
    this.descricaoFornecedorSap = descricaoFornecedorSap;
    this.codigoFornecedorSap = codigoFornecedorSap;
    this.numeroContrato = numeroContrato;
    this.dia = dia;
    this.sku = sku;
    this.descricao = descricao;
    this.quantidadePlanejada = quantidadePlanejada;
    this.quantidadeProduzida = quantidadeProduzida;
    this.quantidadeFaturada = quantidadeFaturada;
    this.dataCarregamento = dataCarregamento;
    this.dataEntregaPrevista = dataEntregaPrevista;
    this.dataEntrega = dataEntrega;
    this.codigoCentroDestino = codigoCentroDestino;
    this.descricaoCentroDestino = descricaoCentroDestino;
    this.statusEntrega = statusEntrega;
    this.otif = otif;
    this.lostShelfLife = lostShelfLife;
    this.justificativa = justificativa;
    this.quantidadeCompensacao = quantidadeCompensacao;
    this.recupera = recupera;
    this.semana = semana;
    this.compensa = compensa;
    this.sobra = sobra;
    this.falta = falta;
    this.desvio = desvio;
    this.semanaCompensacao = semanaCompensacao;
    this.dataCompensacao = dataCompensacao;
  }

  static toJson(model: DashOtif): string {
    return JSON.stringify(model);
  }

  static fromJson(json: object[]): DashOtif[] {
    return json.map((item: any) => {
      return new DashOtif(
        item["descricaoFornecedorSap"],
        +item["codigoFornecedorSap"],
        +item["numeroContrato"],
        new Date(item["dia"]),
        +item["sku"],
        item["descricao"],
        +item["quantidadePlanejada"],
        +item["quantidadeProduzida"],
        +item["quantidadeFaturada"],
        new Date(item["dataCarregamento"]),
        new Date(item["dataEntregaPrevista"]),
        new Date(item["dataEntrega"]),
        +item["codigoCentroDestino"],
        item["descricaoCentroDestino"],
        item["statusEntrega"],
        +item["otif"],
        +item["lostShelfLife"],
        item["justificativa"],
        item["quantidadeCompensacao"],
        item["recupera"],
        item["semana"],
        item["compensa"],
        item["sobra"],
        item["falta"],
        item["desvio"],
        item["semanaCompensacao"],
        item["dataCompensacao"]
      );
    });
  }

}